// campioneTemplate — etichetta del PASTO CAMPIONE (T-229), condivisa (T-279).
//
// Va sul contenitore del campione conservato 72h in cella (capitolati
// ristorazione collettiva). Usata sia da ProductionDayPage (prelievo campione)
// sia da LabelsPage (ristampa dalla sezione apposita del dialog di ristampa).
// L'etichetta campione è "integrata" nel lotto di base: NON genera un evento
// label_printed a sé (non intasa lo Storico) — il prelievo è registrato su
// productions.sample_taken_at; questo modulo serve solo a STAMPARLA.

export const SAMPLE_RETENTION_HOURS = 72;

export interface CampioneTemplateElement {
  id: string;
  type: 'text' | 'qr';
  x_mm: number;
  y_mm: number;
  width_mm?: number;
  height_mm?: number;
  font_size_pt?: number;
  font_weight?: 'normal' | 'bold';
  align?: 'left' | 'center' | 'right';
  binding: string;
}

export interface CampioneTemplate {
  id: string;
  name: string;
  preset: string;
  width_mm: number;
  height_mm: number;
  required_allergens: boolean;
  elements: CampioneTemplateElement[];
}

export const CAMPIONE_TEMPLATE: CampioneTemplate = {
  id: 'trackeat-campione-default',
  name: 'Etichetta campione 50×30 mm',
  preset: 'campione',
  width_mm: 50,
  height_mm: 30,
  required_allergens: false,
  elements: [
    { id: 'h', type: 'text', x_mm: 0,   y_mm: 0.5,  width_mm: 50, height_mm: 5.5, font_size_pt: 12, font_weight: 'bold', align: 'center', binding: '★ CAMPIONE ★' },
    { id: 'n', type: 'text', x_mm: 0.5, y_mm: 6.5,  width_mm: 49, height_mm: 6.5, font_size_pt: 8,  font_weight: 'bold', binding: '{{ product | upper }}' },
    { id: 'p', type: 'text', x_mm: 0.5, y_mm: 13.5, width_mm: 49, height_mm: 3.2, font_size_pt: 7,  binding: 'Prelievo {{ prepared_at | date:DD/MM/YY HH:mm }}' },
    { id: 'c', type: 'text', x_mm: 0.5, y_mm: 17,   width_mm: 49, height_mm: 3.2, font_size_pt: 7,  binding: 'Conservare 72h in cella' },
    { id: 'e', type: 'text', x_mm: 0.5, y_mm: 20.5, width_mm: 49, height_mm: 3.2, font_size_pt: 7,  font_weight: 'bold', binding: 'Eliminare dopo {{ expires_at | date:DD/MM/YY HH:mm }}' },
    { id: 'l', type: 'text', x_mm: 0.5, y_mm: 24,   width_mm: 49, height_mm: 3.2, font_size_pt: 7,  binding: 'Lotto: {{ lp_code }}' },
  ],
};

export interface CampioneLabelInput {
  product: string;
  lp_code: string | null;
  /** ISO del prelievo campione (productions.sample_taken_at); fallback = ora. */
  prelievo_at: string;
}

/** Dati per il binding del template campione (prelievo + scadenza 72h). */
export function buildCampioneLabelData(input: CampioneLabelInput): Record<string, unknown> {
  const prepared = input.prelievo_at;
  const expires = new Date(new Date(prepared).getTime() + SAMPLE_RETENTION_HOURS * 3600 * 1000).toISOString();
  return {
    product: input.product,
    prepared_at: prepared,
    now: prepared,
    expires_at: expires,
    lp_code: input.lp_code ?? '',
    lot: input.lp_code ?? '',
    trace_url: '',
    allergens: [],
    ingredients: [],
  };
}
